import React, { useState, useEffect } from 'react';
import { useData } from '../../../contexts';
import {
  DataGrid,
  gridClasses,
  GridEventListener,
  GridToolbar,
  gridPageCountSelector,
  useGridApiContext,
  GridPagination,
  useGridSelector,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  gridPreferencePanelStateSelector,
  gridFilterActiveItemsSelector,
  GridPreferencePanelsValue,
  GridFilterOperator,
  GridCellParams,
  GridColDef,
  GridFilterItem,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';
import { TablePaginationProps } from '@mui/material/TablePagination';
import { scrollToRef } from '../../../utils/utils';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Menu, MenuItem } from 'react-pro-sidebar';
import { Backdrop, Badge, Grid } from '@mui/material';
import { MdHelpOutline, MdOutlineInfo } from 'react-icons/md';
import { navigate } from 'gatsby';
import FilterListIcon from '@mui/icons-material/FilterList';

import {
  ArrowNavigationInteractieve,
  ArrowNavigationInteractieveTop,
} from '../../ArrowNavigation/ArrowNavigationInteractieve';
import { SelectionPanel } from './SelectionMenuComponents/SelectionPanel';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../Tooltip/Tooltip';

export const InteractieveToolTable = (props: any) => {
  const {
    data,
    columns,
    refToScrollTo,
    gemeenteLijst,
    benchmarkLijst,
    setBenchmarkLijst,
    toggled,
    current,
    themas,
    isLoading,
    indicatorThema,
    d_ruimte,
    additionalData,
  } = props;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);

  const {
    colors,
    selectedGemeente,
    selectedBenchmarks,
    selectedIndicators,
    selectedIndicator,
    selectedIndicatorData,
    setSelectedIndicator,
    setSelectedIndicators,
    setSelectedIndicatorData,
    // columnVisibilityModel,
    // setColumnVisibilityModel,
    // getVisibilityModel,
    setSelectedGemeente,
    setSelectedBenchmarks,
    interfaceColor,
    setSearchParams,
  } = useData();

  useEffect(() => {
    toggled && handleOpen();
  }, [toggled]);

  function useUrlUpdate(url: string) {
    if (typeof window !== `undefined` && typeof url !== `undefined`) {
      window.history.pushState({}, '', url);
    }
    return;
  }

  const handleRowClick: GridEventListener<'rowClick'> = (params) => {
    // const url = `?gemeente=${selectedGemeente.ruimte}&indicator=${params.row?.detail?.ido}`;
    // setSearchParams((params) => {
    //   params.set('gemeente', selectedGemeente.ruimte);
    //   params.set('indicator', params.row?.detail?.ido);
    //   return params;
    // });

    // const trimmedUrl = window.location.href.split('/').shift();
    // const path =
    //   additionalData?.pageSettings?.relationships?.field_dashboard?.path?.alias;

    // const url = `${trimmedUrl}${path}?gemeente=${selectedGemeente.ruimte}`;

    // useUrlUpdate(url);

    params.row.id !== undefined && setSelectedIndicator(params.row.id);
    params.row !== undefined && setSelectedIndicatorData(params.row);
    scrollToRef(refToScrollTo);
  };

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <MuiPagination
        color={'primary'}
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
      />
    );
  }

  function CustomPagination(props: any) {
    return (
      <div>
        <GridPagination
          style={{ position: 'relative', right: 160 }}
          ActionsComponent={Pagination}
          labelRowsPerPage={'Indicatoren per pagina'}
          labelDisplayedRows={function defaultLabelDisplayedRows({
            from,
            to,
            count,
          }) {
            return `${from}–${to} van ${
              count !== -1 ? count : `meer dan ${to}`
            }`;
          }}
          {...props}
        />
        <ArrowNavigationInteractieve
          up={null}
          down={refToScrollTo}
          current={current}
        />
      </div>
    );
  }

  const GridToolbarUpdateSelecties = () => {
    return (
      <div
        className={'vl-typography'}
        style={{
          marginLeft: 'auto',
          marginRight: '8px',
          cursor: 'pointer',
          paddingRight: '8px',
          paddingLeft: '8px',
          backgroundColor: interfaceColor,
          borderRadius: 24,
          position: 'relative',
          top: '0px',
        }}
      >
        <Button
          onClick={handleOpen}
          style={{ marginBottom: 0, color: 'white', height: '28px' }}
        >
          Pas je selecties aan
        </Button>

        <SelectionPanel
          open={open}
          setOpen={setOpen}
          themas={themas}
          indicatorThema={indicatorThema}
          gemeenteLijst={gemeenteLijst}
          selectedGemeente={selectedGemeente}
          selectedBenchmarks={selectedBenchmarks}
          benchmarkLijst={benchmarkLijst}
          setBenchmarkLijst={setBenchmarkLijst}
          d_ruimte={d_ruimte}
        />
      </div>
    );
  };

  const GridToolbarHelp = () => {
    return (
      <div
        className={'vl-typography'}
        style={{
          paddingRight: '8px',
        }}
      >
        <Tooltip>
          <TooltipTrigger
            style={{
              width: '30px',
              top: '3px',
              position: 'relative',
              display: 'inline',
            }}
          >
            <MdHelpOutline
              style={{
                cursor: 'pointer',
                fontSize: '24px',
                color: interfaceColor,
              }}
            />
          </TooltipTrigger>
          <TooltipContent className="Tooltip">
            <p>
              Klik op een rij in het overzicht van de indicatoren om de details
              van de indicator te bekijken. <br />
              Voor sommige indicatoren zijn niet voor alle benchmarks data
              beschikbaar.
            </p>
          </TooltipContent>
        </Tooltip>
      </div>
    );
  };

  function CustomNoRowsOverlay(props: any) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        Data is aan het laden ..
      </div>
    );
  }

  function CustomNoResultsOverlay(props: any) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        Geen resultaten
      </div>
    );
  }

  function CustomFilterButton() {
    const apiRef = useGridApiContext();
    const preferencePanel = useGridSelector(
      apiRef,
      gridPreferencePanelStateSelector,
    );
    const activeFilters = useGridSelector(
      apiRef,
      gridFilterActiveItemsSelector,
    );

    const toggleFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
      const { open, openedPanelValue } = preferencePanel;
      if (open && openedPanelValue === GridPreferencePanelsValue.filters) {
        apiRef.current.hideFilterPanel();
      } else {
        apiRef.current.showFilterPanel();
      }
    };

    return (
      <Button
        size="small"
        aria-label={apiRef.current.getLocaleText('toolbarFiltersLabel')}
        startIcon={
          <Badge badgeContent={activeFilters.length} color="primary">
            <FilterListIcon />
          </Badge>
        }
        onClick={toggleFilter}
      >
        {apiRef.current.getLocaleText('toolbarFilters')}
      </Button>
    );
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton /> */}
        {/* <GridToolbarFilterButton
          color="primary"
          style={{ paddingLeft: '16px' }}
        /> */}
        <CustomFilterButton />
        {/* <GridToolbarDensitySelector /> */}
        {/* <GridToolbarExport /> */}
        <GridToolbarUpdateSelecties />
        <ArrowNavigationInteractieveTop
          up={null}
          down={null}
          current={current}
        />{' '}
        <GridToolbarHelp />
      </GridToolbarContainer>
    );
  }

  return (
    <>
      {/* {isLoading && (
        <Modal
          open={true}
          onClose={() => null}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          slots={{ backdrop: Backdrop, baseTooltip: null }}
          slotProps={{
            backdrop: {
              sx: {
                zIndex: 20,
                backgroundColor: 'rgba(255, 255, 255, 0,5)',
              },
            },
          }}
        >
          <div
            style={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            Loading...
          </div>
        </Modal>
      )} */}
      <div
        style={{
          minWidth: '900px',
          width: 'calc(100% - 32px)',
          minHeight: '400px',
          height: '99vh',
          alignItems: 'center',
          paddingTop: '8px',
          display: 'flex',
          justifyContent: 'center',
          margin: 'auto',
        }}
      >
        <DataGrid
          loading={isLoading}
          localeText={{
            toolbarFilters: 'Zoek op trefwoord',
            filterOperatorContains: 'bevat',
            filterOperatorEquals: 'is gelijk aan',
            filterOperatorStartsWith: 'start met',
            filterOperatorEndsWith: 'eindigt met',
            filterPanelColumns: 'Veld',
            filterPanelInputLabel: 'Waarde',
            filterPanelDeleteIconLabel: 'Wissen',
            filterPanelInputPlaceholder: 'Trefwoord',
          }}
          disableColumnMenu
          disableRowSelectionOnClick
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          pagination
          density="comfortable"
          rows={data}
          columns={columns}
          onRowClick={handleRowClick}
          slots={{
            toolbar: CustomToolbar,
            pagination: CustomPagination,
            noRowsOverlay: CustomNoRowsOverlay,
            noResultsOverlay: CustomNoResultsOverlay,
          }}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
            // columns: {
            // columnVisibilityModel: getVisibilityModel(),
            // },
          }}
          // columnVisibilityModel={columnVisibilityModel}
          // onColumnVisibilityModelChange={(newModel) =>
          //   setColumnVisibilityModel(newModel)
          // }
          pageSizeOptions={[5, 10, 25, 50, 100]}
          // getRowHeight={() => 'auto'}
          // rowHeight={(selectedBenchmarks.length + 1) * 50 + 20}
          getRowHeight={(params) => {
            let factor = 0;

            if (
              params.model?.topLevel === 2 &&
              params.model?.detail?.visualisatieType !== 'V_Aandeel_meerdere'
            ) {
              params.model.data.forEach((c: any) => {
                c.data.forEach((b: any) => {
                  if (b.showInTable === undefined || b.showInTable === 1)
                    factor += 1;
                });
              });
            } else {
              params.model.data.forEach((b: any) => {
                if (b.showInTable === undefined || b.showInTable === 1)
                  factor += 1;
              });
            }

            return factor * 122 + 80 + 24;
          }}
          getEstimatedRowHeight={() => 166}
          sx={{
            // boxShadow: 0,
            //border: 0,

            // paddingRight: '8px',
            backgroundColor: '#FFF',

            '& .color--cell': {
              color: 'primary.main',
            },

            '&  .MuiDataGrid-columnHeaders': {
              paddingTop: '8px',
              height: '48px !important',
              minHeight: '48px !important',
            },

            '& .MuiPagination-ul': {
              listStyleType: 'none',
              '& li': {
                float: 'left',
              },
            },

            '& .MuiButton-text': {
              fontSize: '1.3rem',
            },

            '& .MuiInputBase-root': {
              fontSize: '1.4rem',
            },

            '& .MuiTablePagination-selectLabel': {
              margin: '0',
            },
            '& .MuiTablePagination-displayedRows': {
              margin: '0',
            },

            '& .MuiDataGrid-columnHeader:focus': {
              outline: 'none',
            },

            '& .MuiDataGrid-cell': {
              py: '12px',
              borderBottom: 'none',
              whiteSpace: 'normal !important',
              wordWrap: 'break-word !important',

              '&:hover': {
                color: 'primary.dark',
                textDecoration: 'underline',
              },

              '&:focus': {
                outline: 'none',
              },
            },

            '& .MuiDataGrid-row': {
              cursor: 'pointer',
              borderBottom: '1px solid #EEE',
              // borderBottom: 'none',
              '&:hover': {
                backgroundColor: '#fff',
              },

              '&:focus': {
                outline: 'none',
              },
            },

            '& .even': {
              backgroundColor: '#fff',
            },

            // '& li .Mui-selected': {
            //   color: 'white',
            //   backgroundColor: interfaceColor,
            // },

            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
              width: '0.8em',
              height: '0.8em',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
              background: '#f1f1f1',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
              background: '#555',
            },
            '& .MuiDataGrid-virtualScroller': {
              // scrollbarColor: 'red blue',
              scrollbarWidth: 'thin',
            },
          }}
        />
      </div>
    </>
  );
};
